import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { createTheme } from '@mui/material';

import { useSelector } from 'react-redux';
import CustomTableContainer from '../Common/Table/CustomTableContainer';
import ReleaseComponentsModal from './modals/releaseComponents';
import { Button } from '@material-ui/core';
import AddReleaseModal from './modals/addRelease';
import { FILTER_TYPE } from '../../util/filters/filterConstants';
import { FilterManager } from '../../util/filters/filterManager';

const theme_bp = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 680,
      md: 850,
      lg: 1200,
      xl: 1536,
    },
  },
});

const useStyles = makeStyles({
  addReleaseButton: {
    marginBottom: "10px"
  }
});

export default function AlgReleases(props) {
  const [processedReleases, setProcessedReleases] = useState([]);
  const releaseData = useSelector((state) => state.internal.algReleases);
  const algData = useSelector((state) => state.internal.algs);
  const [modalData, setModalData] = useState({ open: false });
  const [addRelease, setAddRelease] = useState(false);
  const classes = useStyles();

  const filterManagerRef = useRef(null);
  if (!filterManagerRef.current) {
    filterManagerRef.current = FilterManager.Builder
      .addFilter(FILTER_TYPE.ALG_RELEASE.ID, true)
      .addFilter(FILTER_TYPE.ALG_RELEASE.NAME, true)
      .addFilter(FILTER_TYPE.ALG_RELEASE.FRAMEWORK, true)
      .addFilter(FILTER_TYPE.ALG_RELEASE.MODEL_COUNT, true)
      .addFilter(FILTER_TYPE.ALG_RELEASE.MODEL_IDS, true)
      .addFilter(FILTER_TYPE.ALG_RELEASE.NORMALIZATION, true)
      .addFilter(FILTER_TYPE.ALG_RELEASE.SENSITIVITY, true)
      .build()
  }
  const filterManager = filterManagerRef.current;

  const handleClick = (event, row) => {
    const newModalData = {
      open: true,
      components: row.release_data,
      name: row.release_name
    };
    setModalData(newModalData);
  }

  const handleClose = () => {
    setModalData({ open: false });
  }

  useEffect(() => {
    if (releaseData) {
      setProcessedReleases(
        releaseData.map((release, index) => {
          return {
            ...filterManager.generateDataMap(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, release),
            id: index,
            release_data: release.components,
          }
        })
      );
    }

  }, [releaseData]);

  return (
    <>
      <Button onClick={() => setAddRelease(!addRelease)} variant="outlined" className={classes.addReleaseButton}>
        <span>
          Create Release
        </span>
      </Button>
      <CustomTableContainer
        defaultOrder="desc"
        defaultOrderHeader={FILTER_TYPE.ALG_RELEASE.ID}
        headers={filterManager.getHeaders()}
        filterManager={filterManager}
        rowData={processedReleases}
        paginationOptions={[5, 10, 25, 50, 100]}
        defaultPaginationOption={25}
        clickAction={handleClick}
      />
      {
        modalData && modalData.components && modalData.name &&
        (<ReleaseComponentsModal
          components={modalData.components}
          name={modalData.name}
          open={modalData.open}
          algs={algData ? algData : []}
          handleClose={handleClose}
        />)
      }
      <AddReleaseModal
        open={addRelease}
        algs={algData ? algData : []}
        handleClose={() => setAddRelease(false)}
      />
    </>
  );
}
